<template>
  <div class="layout">
    <Layout>
      <Sider hide-trigger collapsible v-model="toggle" :collapsed-width="0" :width="256">
        <LayoutSider></LayoutSider>
      </Sider>
      <Layout>
        <Header>
          <LayoutHeader :toggle="toggle"></LayoutHeader>
        </Header>
        <Content style="overflow: auto;">
          <nuxt-child />
          <notice></notice>
          <noticeOnlineView ref="noticeOnlineViewRef" ></noticeOnlineView>
        </Content>
      </Layout>
      
    </Layout>
    
  </div>
</template>
<script>
import LayoutHeader from "~/components/Layout/header";
import LayoutSider from "~/components/Layout/sider";
import notice from "~/components/Notice/notice";
import Cookie from "js-cookie";
import noticeOnlineView from "~/components/Notice/view";

export default {
  components: {
    LayoutHeader,
    LayoutSider,
    notice,
    noticeOnlineView
  },
  data() {
    return {
      // toggle: false,
      timer:null
    };
  },
  computed: {
    toggle () {
      return this.$store.state.route.toggle;
    }
  },
  middleware: "userAuth",
  mounted() {
    let userInfo = Cookie.get("userInfo");
    userInfo = JSON.parse(Cookie.get("userInfo") || '{}')
    this.getMessageInfo()
    try {
      this.initListener();
    } catch (error) {

    }
    this.$store.dispatch("im/user/login", userInfo.fwUserName);
    
  },
  beforeDestroy(){
    if(this.timer) {
      clearInterval(this.timer); //关闭
    }
  },
  methods: {
    getMessageInfo(){
      let _this = this
      this.timer = setInterval(function(){
        let now = new Date().getTime()
        let messageTime = Cookie.get("messageTime");
        // console.log(now)
        if(messageTime == null || now -messageTime > 30*60*1000){
          Cookie.set("messageTime",now)
          // _this.$nextTick(()=>{
            _this.$refs.noticeOnlineViewRef.show()
          // })
          
        }
      }, 1000);
    },
    initListener() {
      // 登录成功后会触发 SDK_READY 事件，该事件触发后，可正常使用 SDK 接口
      this.tim.on(this.TIM.EVENT.SDK_READY, this.onReadyStateUpdate, this);
      // SDK NOT READT
      this.tim.on(this.TIM.EVENT.SDK_NOT_READY, this.onReadyStateUpdate, this);
      // 被踢出
      this.tim.on(this.TIM.EVENT.KICKED_OUT, ({ data: { type } }) => {
        const message = type === this.TIM.TYPES.KICKED_OUT_MULT_ACCOUNT ? "您的账号已在其他页面登录" : "您的账号已在其他设备登录";
        this.$message.error(message);
        this.$store.commit("im/user/toggleIsLogin", false);
        this.$store.commit("im/userreset");
      });
      // SDK内部出错
      this.tim.on(this.TIM.EVENT.ERROR, this.onError);
      // 收到新消息
      this.tim.on(this.TIM.EVENT.MESSAGE_RECEIVED, this.onReceiveMessage);
      // 会话列表更新
      this.tim.on(this.TIM.EVENT.CONVERSATION_LIST_UPDATED, event => {
        this.$store.commit("im/conversation/updateConversationList", event.data);
      });
      // 群组列表更新
      this.tim.on(this.TIM.EVENT.GROUP_LIST_UPDATED, event => {
        // this.$store.commit("im/group/updateGroupList", event.data);
      });
      // 收到新的群系统通知
      this.tim.on(this.TIM.EVENT.GROUP_SYSTEM_NOTICE_RECERIVED, event => {
        const isKickedout = event.data.type === 4;
        const isCurrentConversation = `GROUP${event.data.message.payload.groupProfile.groupID}` === this.currentConversation.conversationID;
        // 在当前会话被踢，需reset当前会话
        if (isKickedout && isCurrentConversation) {
          this.$store.commit("im/conversation/resetCurrentConversation");
        }
        Notification({
          title: "新系统通知",
          message: translateGroupSystemNotice(event.data.message),
          duration: 3000,
          onClick: () => {
            const SystemConversationID = "@TIM#SYSTEM";
            this.$store.dispatch("im/conversation/checkoutConversation", SystemConversationID);
          }
        });
      });
    },
    onReceiveMessage({ data: messageList }) {
      this.handleAt(messageList);
      this.$store.commit("im/conversation/pushCurrentMessageList", messageList);
    },
    onError({ data: error }) {
      this.$message.error(error.message);
    },
    onReadyStateUpdate({ name }) {
      const isSDKReady = name === this.TIM.EVENT.SDK_READY ? true : false;
      this.$store.commit("im/user/toggleIsSDKReady", isSDKReady);
      console.log(isSDKReady);
      if (isSDKReady) {
        this.tim.getMyProfile().then(({ data }) => {
          this.$store.commit("im/user/updateCurrentUserProfile", data);
        });
        this.$store.dispatch("im/blacklist/getBlacklist");
      }
    },
    /**
     * 处理 @ 我的消息
     * @param {Message[]} messageList
     */
    handleAt(messageList) {
      // 筛选有 @ 符号的文本消息
      const atTextMessageList = messageList.filter(
        message =>
          message.type === this.TIM.TYPES.MSG_TEXT &&
          message.payload.text.includes("@")
      );
      for (let i = 0; i < atTextMessageList.length; i++) {
        const message = atTextMessageList[i];
        const matched = message.payload.text.match(/@\w+/g);
        if (!matched) {
          continue;
        }
        // @ 我的
        if (matched.includes(`@${this.currentUserProfile.userID}`)) {
          // 当前页面不可见时，调用window.Notification接口，系统级别通知。
          if (document.hidden) {
            this.notifyMe(message);
          }
          Notification({
            title: `有人在群${message.conversationID.slice(5)}提到了你`,
            message: message.payload.text,
            duration: 3000
          });
          this.$bus.$emit("new-messsage-at-me", {
            data: { conversationID: message.conversationID }
          });
        }
      }
    },
    /**
     * 使用 window.Notification 进行全局的系统通知
     * @param {Message} message
     */
    notifyMe(message) {
      // 需检测浏览器支持和用户授权
      if (!("Notification" in window)) {
        return;
      } else if (window.Notification.permission === "granted") {
        this.handleNotify(message);
      } else if (window.Notification.permission !== "denied") {
        window.Notification.requestPermission().then(permission => {
          // 如果用户同意，就可以向他们发送通知
          if (permission === "granted") {
            this.handleNotify(message);
          }
        });
      }
    },
    handleNotify(message) {
      const notification = new window.Notification("有人提到了你", {
        body: message.payload.text
      });
      notification.onclick = () => {
        window.focus();
        this.$store.dispatch("im/conversation/checkoutConversation", message.conversationID);
        notification.close();
      };
    }
  },
  created() {}
};
</script>
<style lang="less">
.layout {
  height: 100%;
  .ivu-layout {
    height: 100%;
    position: relative;
    overflow: hidden;
  }
  .ivu-layout > .ivu-layout-sider {
    background: #fff;
    box-shadow: 2px 0 8px 0 rgba(29, 35, 41, 0.05);
    z-index: 10;
  }
  .ivu-layout-content {
    background: #f0f2f5;
    padding: 16px;
    // display: flex;
    box-sizing: border-box;
  }

  .ivu-layout > .ivu-layout-header {
    background: #fff;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    position: 'fixed';
    padding: 0 24px;
    height: 32px;
    line-height: 32px;
  }
}
.layout > .ivu-layout {
  flex-direction: row;
}
</style>
